import React from 'react';
import {
  faChartSimple,
  faCoins,
  faDiamond,
} from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { FeatureModalContainer } from '@components/NewFeatures/FeatureModalContainer';
import { SubSection } from '@components/NewFeatures/FeatureModalSubSection';
import { Button } from '@components/main-components/button/Button';
import { StandardModal } from '@components/main-components/modals/StandardModal';
import { useModal } from '@context/modal';
import { NAV_LINKS } from '@utils/constants';

export const LeaderboardFeatureModal = () => {
  const { closeCancelModal } = useModal();

  const body = (
    <FeatureModalContainer icon={faChartSimple}>
      <div className="flex w-full flex-col items-center justify-center gap-y-2 text-base800">
        <h2 className="font-title text-title-m font-medium sm:text-title-l ">
          Introducing Sound Leaderboard
        </h2>

        <p className="flex text-center font-base text-base-m sm:text-base-l ">
          A new way to earn points to unlock badges and
          <br />
          influence the Viral Sound charts
        </p>
      </div>

      <div className="mt-2 flex w-full flex-col gap-y-6">
        <SubSection icon={faCoins} title="Earn Points">
          Earn points by collecting songs, discovering new artists, and more to increase your
          influence the Viral Sounds charts.
        </SubSection>

        <SubSection icon={faChartSimple} title="Climb Leaderboard">
          See how you rank among others and strive for the top spots!
        </SubSection>

        <SubSection icon={faDiamond} title="Unlock Badges">
          Unlock Silver, Gold, and Platinum, and Diamond badges as you accumulate points.
        </SubSection>
      </div>
    </FeatureModalContainer>
  );

  return (
    <StandardModal
      body={body}
      closeModal={closeCancelModal}
      callToAction={
        <div className="flex w-full justify-between gap-3 [&_a]:w-full">
          {/* TODO: add learn more link */}
          <Button variant="tertiary" size="L" label="Learn More" fullWidth />

          <Button
            variant="primary"
            size="L"
            label="Explore"
            fullWidth
            href={NAV_LINKS.Leaderboard}
          />
        </div>
      }
    />
  );
};
